import { PermissionRoles } from "../../types/enums";
import { Stack } from "@mui/material";
import { permissionRolesItems } from "../../types/genereal";

export const PermissionRoleMapper = ({ role }: { role: PermissionRoles }) => {
  return (
    <Stack alignItems="flex-start">
      <span
        style={{
          borderRadius: "16px",
          padding: "5px 12px",
          fontSize: "13px",
          lineHeight: "12px",
          fontWeight: 500,
          color: permissionRolesItems[role].color,
          backgroundColor: permissionRolesItems[role].backgroundColor,
          border: `1px solid ${permissionRolesItems[role].borderColor}`,
          textAlign: "left",
          userSelect: "none",
          letterSpacing: "0.35px",
        }}
      >
        {permissionRolesItems[role].title}
      </span>
    </Stack>
  );
};
